import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AppSettings {
  showCoverImages: boolean;
}

interface AppSettingsStore extends AppSettings {
  setShowCoverImages: (show: boolean) => void;
  toggleCoverImages: () => void;
}

const defaultSettings: AppSettings = {
  showCoverImages: true,
};

export const useAppSettings = create<AppSettingsStore>()(
  persist(
    (set) => ({
      ...defaultSettings,
      setShowCoverImages: (showCoverImages) => set({ showCoverImages }),
      toggleCoverImages: () => set((state) => ({ showCoverImages: !state.showCoverImages })),
    }),
    {
      name: 'app-settings',
      version: 1,
      storage: createJSONStorage(() => localStorage),
    }
  )
);
